// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionFeaturesMaybe_root__3ZINx"};